import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Table, Icon, Header, Card, List, Button } from 'semantic-ui-react'
import { toCurrency } from '../../../../config/constants'
import * as UiConsts from '../../../../config/UiConstants';
import CommPay from './CommPay'
import ViewLargeProjectCostsMobile from './ViewLargeProjectCostsMobile'
import CostMarkProjectCost from './CostMarkProjectCost'
import AddDate from './AddDates'
import AddPaymentDate from './AddPaymentDate';
import MarkProjectPayNow from './MarkProjectPayNow';

export function RenderProjectListCard(props) {


    const ShowDeliveryDate = props => props.item.datedelivered == 'None'
        ? <AddDate projectId={props.item.idlargeprojects} user={props.user} viewOnMobile={true} />
        : ''

    const ShowPaymentDate = props => props.item.datepaid == 'None'
        ? <AddPaymentDate projectId={props.item.idlargeprojects} user={props.user} viewOnMobile={true} />
        : ''

    const showCommPay = props.user && props.user.email == 'ivanmworozi@gmail.com'
        ? <CommPay project={props.project} user={props.user} />
        : ''

    return (
        <div>
            <Card>
                <Card.Content>
                    <Card.Header>{props.project.name} </Card.Header>
                    <Card.Header>PROJECT ID: {props.project.idlargeprojects} </Card.Header>
                    <Card.Header>PAYMENT:{toCurrency(props.project.totalpayment)} </Card.Header>
                    <Card.Header>COST:{toCurrency(props.project.totalcost)} </Card.Header>
                    <Card.Header>PROFIT:{toCurrency(props.project.profit)} </Card.Header>
                    <Card.Description>
                        CUSTOMER: {props.project.customer}
                    </Card.Description>
                    <Card.Description>
                        DATE PAID: {props.project.datepaid}
                    </Card.Description>
                    <Card.Description>
                        DATE DELVRD: {props.project.datedelivered}
                    </Card.Description>
                    
                    <Button color='WHITE'><Link to={'/dashboard/mobileEnterProjectCosts/' + props.project.idlargeprojects}>VIEW PROJECT</Link></Button>
                    <br />

                    {/* <CopyToClipboard text={'https://printboda.com/dashboard/viewLargeProject/' + props.project.idlargeprojects} onCopy={() => console.log("text copied")}>
                        <Button color='brown'>COPY PROJECT LINK</Button>
                    </CopyToClipboard> */}

                    <ViewLargeProjectCostsMobile projectId={props.project.idlargeprojects} />
                    {/* {showCommPay} */}
                    {/* <CommPay project={props.project} user={props.user} /> */}
                    {/* <AddDate projectId={item.idlargeprojects} user={props.user}  viewOnMobile={true}/> */}
                    <ShowDeliveryDate projectId={props.project.idlargeprojects} item={props.project} user={props.user} />
                    <ShowPaymentDate projectId={props.project.idlargeprojects} item={props.project} user={props.user} />
                </Card.Content>
            </Card>
        </div>
    )
}


export function RenderProjectListRow(props) {

    return (
        <div>
            <Table.Row>
                <Table.Cell> {props.project.idlargeprojects} </Table.Cell>
                <Table.Cell> {props.project.name} </Table.Cell>
                <Table.Cell> {props.project.largeprojectcustomer.customername} </Table.Cell>
                <Table.Cell> {props.project.datecreated} </Table.Cell>
                <Table.Cell> {toCurrency(props.project.totalpayment)} </Table.Cell>
                <Table.Cell> {props.project.enteredby.name} </Table.Cell>
                <Table.Cell> {props.project.paymentstatus}</Table.Cell>
                <Table.Cell> {props.project.salesperson.name}</Table.Cell>
                <Table.Cell> <Link to={'/dashboard/viewLargeProject/' + props.project.idlargeprojects}>EDIT</Link></Table.Cell>

            </Table.Row>
        </div>
    )
}


export function RenderEditProjectCost(props) {

    const editCostUi = props.user.email == 'ivanmworozi@gmail.com'
        ? <Table.Cell> <CostMarkProjectCost costId={props.item.idlargeprojectcosts} projectId={props.projectId} /> </Table.Cell>
        : <Table.Cell> NONE </Table.Cell>

    return (
        <div>
            {editCostUi}
        </div>
    )
}


export function RenderProjectCommSummary(props) {

    // const addDeliveryDateUi = props.user
    // ? <AddDate
    //     projectId={props.item.idlargeprojects}
    //     user={props.user} />
    // : ''

    // const Greeting = props => <h1>{props.greeting}</h1>;

    const ShowDeliveryDate = props => props.item.datedelivered == 'None'
        ? <AddDate projectId={props.item.idlargeprojects} user={props.user} viewOnMobile={true} />
        : ''

    const ShowPaymentDate = props => props.item.datepaid == 'None'
        ? <AddPaymentDate projectId={props.item.idlargeprojects} user={props.user} viewOnMobile={true} />
        : ''


    const rows = props.projects.length > 0
        ? props.projects.map((item) =>

            <Card>
                <Card.Content>
                    <Card.Header>#{item.idlargeprojects} - {item.name} </Card.Header>
                    <Card.Header>PAYMENT:{toCurrency(item.totalpayment)} </Card.Header>
                    <Card.Header>COST:{toCurrency(item.totalcost)} </Card.Header>
                    <Card.Header>PROFIT:{toCurrency(item.profit)} </Card.Header>
                    <Card.Description>
                        CUSTOMER: {item.customer}
                    </Card.Description>
                    <Card.Description>
                        DATE PAID: {item.datepaid}
                    </Card.Description>
                    <Card.Description>
                        DATE DELVRD: {item.datedelivered}
                    </Card.Description>
                    <Link to={'/dashboard/viewLargeProject/' + item.idlargeprojects} target="_blank">VIEW PROJECT</Link>
                    <br />

                    <CopyToClipboard text={'https://printboda.com/dashboard/viewLargeProject/' + item.idlargeprojects} onCopy={() => console.log("text copied")}>
                        <Button color='brown'>COPY PROJECT LINK</Button>
                    </CopyToClipboard>

                    <ViewLargeProjectCostsMobile projectId={item.idlargeprojects} />
                    {/* <CommPay project={item} user={props.user} /> */}
                    {/* <AddDate projectId={item.idlargeprojects} user={props.user}  viewOnMobile={true}/> */}
                    <ShowDeliveryDate projectId={item.idlargeprojects} item={item} user={props.user} />
                    <ShowPaymentDate projectId={item.idlargeprojects} item={item} user={props.user} />
                    <MarkProjectPayNow projectId={item.idlargeprojects} user={props.user} />
                </Card.Content>
            </Card>
        )
        : ''
    return (
        props.loading ? <UiConsts.LoadingComponent /> : <div>
            <h2>PROJECTS</h2>
            {rows}
        </div>
    );
}


export function RenderProjectCosts(props) {

    const rows = props.projectCosts.length > 0
        ? props.projectCosts.map((item) =>

            <List.Item>
                {/* <List.Icon name='dollar' /> */}
                <List.Content>
                    <List.Header> ({item.qty}) {item.shirttypes.shirttype} - {toCurrency(item.cost)} (ea) - Total:{toCurrency(item.qty * item.cost)} </List.Header>
                </List.Content>
                <List.Item>{item.description}</List.Item>
                <List.Content floated='center'>
                    <Button fluid ><Link to={'/dashboard/editProjectCost/' + props.projectId + '/' + item.idlargeprojectcosts+ '/mobile'}>EDIT</Link></Button>
                </List.Content>
            </List.Item>
        )
        : ''

    return (
        props.loading ? <UiConsts.LoadingComponent /> : <div>
            <h3>COSTS</h3>
            <List divided size='large'>
                {rows}
            </List>


        </div>
    );
}



export function RenderProjectDictList(props) {


    const rows = props.projects.length > 0
        ? props.projects.map((item) =>

            <Card>
                <Card.Content>
                    <Card.Header>{item.name} </Card.Header>
                    <Card.Header>PAYMENT:{toCurrency(item.totalPayment)} </Card.Header>
                    <Card.Header>COST:{toCurrency(item.totalCost)} </Card.Header>
                    <Card.Header>PROFIT:{toCurrency(item.profit)} </Card.Header>
                    <Card.Description>
                        CUSTOMER: {item.customer}
                    </Card.Description>
                    <Card.Description>
                        DATE PAID: {item.datepaid}
                    </Card.Description>
                    <Card.Description>
                        DATE DELVRD: {item.datedelivered}
                    </Card.Description>
                    <Link to={'/dashboard/viewLargeProject/' + item.idlargeprojects} target="_blank">VIEW PROJECT</Link>
                    <br />



                    <RenderProjectCosts projectCosts={item.projectCosts} loading={props.loading} />
                    <CommPay project={item} user={props.user} />
                </Card.Content>
            </Card>
        )
        : ''

    return (
        props.loading ? <UiConsts.LoadingComponent /> : <div>
            <h2>PROJECTS</h2>
            {rows}
        </div>
    );
}

export function CommObjectUi(props) {

    const numProjects = props.commObject != ''
        ? <Header as='h2' color='blue'>
            {props.commObject.numProject}
            <Header.Subheader>
                Num Projects
    </Header.Subheader>
        </Header>
        : ''

    const totalProfit = props.commObject != ''
        ? <Header as='h2' color='olive'>
            {toCurrency(props.commObject.totalProfit)}
            <Header.Subheader>
                Total Profit
    </Header.Subheader>
        </Header>
        : ''

    const totalCommission =
        <Header as='h2' color='red'>
            {toCurrency(props.commObject.totalCommission)}
            <Header.Subheader>
                Total commission
    </Header.Subheader>
        </Header>

    const totalAmountDue = props.commObject.totalAmountDue
        ? <Header as='h2' color='red'>
            {toCurrency(props.commObject.totalAmountDue)}
            <Header.Subheader>
                totalAmountDue
</Header.Subheader>
        </Header>
        : ''


    return (
        <div>
            {numProjects}
            {totalProfit}
            {totalCommission}
            {totalAmountDue}
        </div>
    )
}

export function SalesPersonApprovedRow(props) {

    const salesRow = props.item.salespersonapproved == 'yes'
        ?
        <div>
            <Icon name='checkmark' />
            {props.item.salespersonapproved}
        </div>

        :
        <div>
            <Icon name='close' />
            {props.item.salespersonapproved}
        </div>

    return (
        <div>
            {salesRow}
        </div>
    )
}


export function CostApprovedRow(props) {

    const row = props.item.costsapprovedyesno == 'yes'
        ? <Table.Cell positive>
            <Icon name='checkmark' />
            {props.item.costsapprovedyesno}
        </Table.Cell>
        : <Table.Cell negative>
            <Icon name='close' />
            {props.item.costsapprovedyesno}
        </Table.Cell>
    return (
        <div>
            {row}
        </div>
    )
}

export function RenderProjectList(props) {

    const rows = props.projects.length > 0
        ? props.projects.map((item) =>
            <Table.Row>
                <Table.Cell> {item.idlargeprojects} </Table.Cell>
                <Table.Cell> {item.name} </Table.Cell>
                <Table.Cell> {item.largeprojectcustomer.customername} </Table.Cell>
                <Table.Cell> {item.datecreated} </Table.Cell>
                <Table.Cell> {toCurrency(item.totalpayment)} </Table.Cell>
                <Table.Cell> {item.enteredby.name} </Table.Cell>
                <Table.Cell> {item.paymentstatus}</Table.Cell>
                <Table.Cell> {item.salesperson.name}</Table.Cell>
                <Table.Cell> <Link to={'/dashboard/viewLargeProject/' + item.idlargeprojects}>EDIT</Link></Table.Cell>
                <CostApprovedRow item={item} />
                {/* <SalesPersonApprovedRow item={item} /> */}
                <Table.Cell> <SalesPersonApprovedRow item={item} /></Table.Cell>
            </Table.Row>)
        : ''

    return (
        props.loading ? <UiConsts.LoadingComponent /> : <div>
            <h2>PROJECTS</h2>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Id</Table.HeaderCell>
                        <Table.HeaderCell>Project</Table.HeaderCell>
                        <Table.HeaderCell>Customer</Table.HeaderCell>
                        <Table.HeaderCell>Date Created</Table.HeaderCell>
                        <Table.HeaderCell>Total Cost</Table.HeaderCell>
                        <Table.HeaderCell>Entered By</Table.HeaderCell>
                        <Table.HeaderCell>PAID</Table.HeaderCell>
                        <Table.HeaderCell>SALES PERSON</Table.HeaderCell>
                        <Table.HeaderCell>EDIT</Table.HeaderCell>
                        <Table.HeaderCell>Costs Appr</Table.HeaderCell>
                        <Table.HeaderCell>SalesPrsn Appr</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {rows}
                </Table.Body>

            </Table>


        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/UiUtils.js